import { h } from '@atomify/jsx';
import { Label } from '@atoms/label/label';
import { Marker } from '@atoms/marker/marker';
import { VirtualTourPointer } from '@features/virtual-tour/types';

export const elementFromPointer = (
    pointer: VirtualTourPointer,
    onPointerClick: (pointer: VirtualTourPointer) => void,
    onPointerHover: (id: string, active: boolean) => void,
): Element => {
    if (pointer.type === 'text') {
        return (
            <div
                class="vr-tour-image-view__pointer vr-tour-image-view__pointer--text"
                js-hook-virtual-tour-text-pointer
                style={{
                    left: `${pointer.position?.[1]}%`,
                    top: `${pointer.position?.[0]}%`,
                }}>
                <Label text={pointer.label || ''} />
            </div>
        );
    } else if (pointer.type === 'label' && pointer.constructionNumber) {
        const { id, status, url, identifier } = pointer.constructionNumber;
        return (
            <button
                data-construction-number-id={id}
                js-hook-virtual-view-label-pointer
                class="vr-tour-image-view__pointer vr-tour-image-view__pointer--label"
                style={{
                    left: `${pointer.position?.[1]}%`,
                    top: `${pointer.position?.[0]}%`,
                }}
                onClick={() => url && (window.location.href = url)}
                onMouseEnter={() => onPointerHover(id!, true)}
                onMouseLeave={() => onPointerHover(id!, false)}>
                <Label
                    classes="vr-tour-image-view__pointer-label"
                    formattedStatusColor={status?.color}
                    text={`# ${identifier || ''}`}
                />
            </button>
        );
    } else {
        const [type, eyeDirection = null] = pointer.type.split('-');
        return (
            <Marker
                classes="vr-tour-image-view__pointer vr-tour-image-view__pointer--marker"
                size="small"
                variant={type === 'eye' ? type : pointer.type}
                tooltip={pointer.label}
                number={`${pointer.amount}`}
                onClick={() => onPointerClick(pointer)}
                eyeDirection={eyeDirection}
                style={{
                    left: `${pointer.position?.[1]}%`,
                    top: `${pointer.position?.[0]}%`,
                }}
            />
        );
    }
};
